import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoTreeListMixin from './KendoTreeListMixin'

export default {
    name: 'kendo-treelist',
    mixins: [ KendoTreeListMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/index.js